import React from 'react';
import { FiArrowRight } from 'react-icons/fi';
import './CaAdultClasses.css';

const CaAdultClasses = ({ onOpenModal }) => {
  return (
    <section className="Ca-adult-classes" id="adult-classes">
      <div className="Ca-adult-classes__container">
        <div className="Ca-adult-classes__grid">
          {/* Left Column: Image */}
          <div className="Ca-adult-classes__image-container">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/Alquran-2.jpg`}
              alt="Adult learning Quran on laptop with headphones"
              className="Ca-adult-classes__img"
            />
          </div>

          {/* Right Column: Copy */}
          <div className="Ca-adult-classes__info">
            <h2 className="Ca-adult-classes__title">
              It Is Never Too Late, Online Quran Classes for Adults in Canada
            </h2>

            <p className="Ca-adult-classes__desc">
              Many adult Muslims grew up without proper Quranic education. Others learned as children but lost fluency over the years. Some accepted Islam later in life and want to connect with the Quran from scratch. Whatever your starting point, Al Quran Lesson offers adult-specific Quran classes that respect your intelligence, honor your schedule, and move at a pace you are comfortable with.
            </p>

            <p className="Ca-adult-classes__desc">
              There is no judgment here. Our tutors are experienced in working with adult learners. People with careers, families, and limited time who are serious about learning properly. Whether your goal is to complete the Quran, memorize the Quran, understand the meaning of what you recite, or simply read correctly with Tajweed, we have a course and a tutor for you.
            </p>

            <button
              onClick={onOpenModal}
              className="Ca-adult-classes__cta-btn"
              style={{ border: 'none', cursor: 'pointer' }}
            >
              <span>Get Free Trial For Classes</span>
              <FiArrowRight className="Ca-adult-classes__cta-arrow" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaAdultClasses;
